import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { URLConstructor } from '../../NonReact/utils/URLBuilder'
import { APIElements, getAppV2APIBasePath, getServletCommandURL } from '../../NonReact/constants/ApiConstants'

export const getAppV2URL = (routeID: RouteID): URLConstructor => getAppV2APIBasePath().appendPathParams(routeID)

export const getURLFromRedirectCommand = (redirectCommand: string, branding?: Nullable<string>): URLConstructor =>
    redirectCommand.toLowerCase().includes('cmd') && branding
        ? getServletCommandURL(branding ?? APIElements.AKIXI_2019, redirectCommand)
        : getAppV2URL(redirectCommand as RouteID)
